import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { useRecoilState } from 'recoil'

import Modal from '@/components/Modal'
import useGetRecoilState from '@/hooks/useGetRecoilState'
import { screenSharingState, useDeviceState } from '@/store/room'
import { ipcInvoke, isElectron } from '@/utils/electron'

import { rtcClient, rtmClient } from '../..'

export default function Index() {
  const oldMainCamera = useRef<string>('')
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const [screenShareTips, setScreenShareTips] = useState(false)

  const [screenSharing, setScreenSharing, getScreenSharing] = useGetRecoilState(screenSharingState)

  useEffect(() => {
    rtmClient.on('ArtScreenShareControl', onArtScreenShare)
    return () => {
      rtmClient.removeListener('ArtScreenShareControl', onArtScreenShare)
    }
  }, [])

  const onArtScreenShare = (id: number, payload: any) => {
    const WebBrowser = document.getElementById('WebBrowser') as HTMLElement
    //  获取浏览器dom
    if (getScreenSharing() || (WebBrowser && !WebBrowser.className.includes('hidden'))) {
      setScreenShareTips(payload?.isShow)
    }
  }
  // 获取屏幕
  const getScreen = async () => {
    try {
      // 通过IPC调用主进程获取
      const screenViaIPC: any = await ipcInvoke('DESKTOP_CAPTURER_GET_SOURCES', {
        method: 'getSources',
        data: { types: ['window'] } // 同时获取屏幕和窗口
      })
      console.log('screenViaIPC', screenViaIPC)
      if (Array.isArray(screenViaIPC?.data)) {
        const [screen] = screenViaIPC.data
        console.log('screen', screen)
        startScreenShare(screen)
      } else {
        console.error('没有可用的屏幕源')
      }
    } catch (error) {
      console.error('获取屏幕源时出错:', error)
    }
  }

  const startScreenShare = async (screen: any) => {
    const { id, bounds } = screen
    try {
      await rtcClient.changeMainCamera({ deviceId: '' })
      setUseDevice({ ...useDevice, mainCamera: '' })
      oldMainCamera.current = useDevice.mainCamera
    } catch (error) {
      console.error('关闭主摄像头失败', error)
    }
    try {
      await rtcClient.changeMainCamera({ deviceId: id, publish: true, screen })
      rtmClient.sendMessage('ArtScreenShareControl', {
        isShow: true
      })
      rtmClient.sendMessage('ArtScreenShareStatus', {
        isOpen: true
      })
      setScreenSharing(true)
    } catch (error) {
      console.error('开启屏幕共享失败', error)
    }
  }

  const overScreenShare = async () => {
    try {
      await rtcClient.changeMainCamera({ deviceId: '', publish: false, screen: {} })
      rtmClient.sendMessage('ArtScreenShareStatus', {
        isOpen: false
      })
      setScreenSharing(false)
    } catch (error) {
      console.error('关闭屏幕共享失败', error)
    }
    if (oldMainCamera.current) {
      try {
        rtcClient.changeMainCamera({ deviceId: oldMainCamera.current, publish: true })
        setUseDevice((v) => ({ ...v, mainCamera: oldMainCamera.current }))
      } catch (error) {
        console.error('开启主摄像头失败', oldMainCamera.current)
        console.error(error)
      }
    }
  }

  return (
    <>
      {/* <div onClick={() => getScreen()} className="anim_btn2 w-[5vh] h-[5vh] screen"></div> */}

      <Modal
        show={screenShareTips && isElectron()}
        title={screenSharing ? '屏幕共享中' : '开启屏幕共享'}
        cancel={() => setScreenShareTips(false)}
        confirm={() => {
          setScreenShareTips(false)
          if (screenSharing) {
            overScreenShare()
          } else {
            getScreen()
          }
        }}
      >
        <div className="text-[#333] text-center">{screenSharing ? '是否关闭共享' : '老师已共享屏幕，快打开你的屏幕共享'}</div>
        {!screenSharing ? <div className="text-[#333] text-center mb-[20px]">方便老师精准指导，高效快乐学习</div> : null}
      </Modal>
    </>
  )
}
